import axios from "axios";

export const createAxiosInstance = async () => {
  const baseURL = process.env.REACT_APP_BASE_URL

  const instance = axios.create({
    baseURL,
    headers: {
      // "Content-Type": "application/json",
      // "X-Requested-With": "XMLHttpRequest",
      "Content-Type ": "application/x-www-form-urlencoded",
    },
  });

  let noAuthRoutes = ['auth/login'];

  // Attach token to every request
  instance.interceptors.request.use(
    async config => {
      const { store } = await import("./store.js");
      const token = store.getState().auth.token;
      const isNoAuthRoute = noAuthRoutes.some(route =>
        config.url?.includes(route),
      );
      if (token && !isNoAuthRoute) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    error => Promise.reject(error),
  );

  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error?.response?.status === 401) {
        if (
          error?.response?.data?.message !==
          "These credentials do not match our records"
        ) {
          const { store } = await import("./store.js");
          const { logout } = await import("./slices/authSlice.js");

          store.dispatch(logout());
          alert("Session Expired, please Relogin!");
        }
      }
      return Promise.reject(error);
    }
  );

  return instance;
};